// src/utils/flattenArtifact.ts

import {IArtifact} from "../context/consumer/objectDetails";
import {getEstimatedDisplayValue} from "../helpers";

export interface IArtifactFlat {
    id: number;
    title: string;
    description: string;
    estimatedValue: string;
    dimensions: string;
    weight: string;
    age: string;
    material: string;
    style: string;
    origin: string;
    condition: string;
    artist: string;
    artistBio: string;
    photos: number[];
}

export function flattenArtifact(a: IArtifact): IArtifactFlat {
    return {
        id: a.id,
        title: a.title,
        description: a.description,
        estimatedValue: getEstimatedDisplayValue(
            a.exactValue,
            a.minimumValue,
            a.maximumValue,
            '-',
        ),
        dimensions: formatDimensions(a.width, a.height, a.depth),
        weight: formatWeight(a.weight),
        age: formatAge(a.exactProductionYear, a.lowerProductionYear, a.upperProductionYear),
        material: a.material || '',
        style: a.style || '',
        origin: a.origin || '',
        condition: a.condition || '',
        artist: a.artist || '',
        artistBio: a.artistBio || '',
        photos: a.photos.map(p => p.id),
    };
}

export function flattenArtifactList(a: any): IArtifactFlat {
    return {
        id: a.id,
        title: a.title,
        description: a.description,
        estimatedValue: getEstimatedDisplayValue(
            a.exactValue,
            a.minimumValue,
            a.maximumValue,
            '-',
        ),
        dimensions: formatDimensions(a.width, a.height, a.depth),
        weight: formatWeight(a.weight),
        age: formatAge(a.exactProductionYear, a.lowerProductionYear, a.upperProductionYear),
        material: a.material || '-',
        style: a.style || '-',
        origin: a.origin || '-',
        condition: a.condition || '-',
        artist: a.artist || '-',
        artistBio: a.artistBio || '-',
        photos: a.photos.map((p: any) => p.id),
    };
}

function formatDimensions(width: number | null, height: number | null, depth: number | null): string {
   const heightV = height ? `${height}'' H` : ``;
   const widthV = width ? `${width}'' W` : ``;
   const depthV = depth ? `${depth}'' D` : ``;

   return [heightV, widthV, depthV].filter((i: string) => i.length).join(' x ');
}

function formatWeight(weight: number | null): string {
    return weight? `${weight} lb.` : `-`
}

function formatAge(exact: number | null, lower: number | null, upper: number | null): string {
    if(exact !== null) {
        return exact < 0 ? `${exact * -1} BC` : `${exact}`;
    }
    if(lower !== null && upper !== null) {
        const lowerV = lower < 0 ? `${lower * -1} BC` : `${lower}`;
        const upperV = upper < 0 ? `${upper * -1} BC` : `${upper}`;
        return `${lowerV} - ${upperV}`;
    }

    return '';
}
